import React from 'react';
export function QualificationsSection() {
  return <section id="qualifikationen" className="w-full py-20 px-6 md:px-12" data-id="element-183">
      <div className="max-w-5xl mx-auto" data-id="element-184">
        <h2 className="text-3xl md:text-2xl font-light text-gray-700 mb-6 text-center" data-id="element-185">
          Unser Erfahrungshorizont
        </h2>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-4xl mx-auto" data-id="element-186">
          Passgenau zu Ihrem Anliegen wenden wir evidenzbasierte, praxiserprobte
          wissenschaftliche Methoden in der Beratung und Psychotherapie an – um
          im Dialog gemeinsam Lösungen zu entwickeln, die sich in Ihrem Alltag
          wirklich bewähren.
        </p>
        <div className="space-y-12" data-id="element-187">
          {/* First Block */}
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-188">
            <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-189">
              <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-190">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9CXprfbNwCE5dqp6VyiYnx/Kachel-Yes.jpg" alt="YES Schriftzug" className="w-full h-auto rounded-lg" data-id="element-191" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-192">
                <h4 className="text-lg font-medium text-gray-700 mb-4" data-id="element-193">
                  Weil komplexe Themen mehr als eine Perspektive verdienen:
                </h4>
                <p className="text-gray-600 mb-4" data-id="element-194">
                  Wir sind zwei Diplom-Psychologinnen mit einer gemeinsamen
                  Basis – dem Psychologiestudium an der Universität Heidelberg
                  mit dem Schwerpunkt klinische Psychologie. Unsere beruflichen
                  Wege haben sich in verschiedenen Umgebungen weiterentwickelt:
                  in Unternehmen, im Coaching und in der therapeutischen Praxis.
                </p>
                <p className="text-gray-600 mb-4" data-id="element-195">
                  Was uns verbindet, ist das Anliegen, Menschen professionell,
                  fundiert und mit klarem Blick durch Veränderungsprozesse zu
                  begleiten – individuell, in Beziehungen oder im beruflichen
                  Umfeld.
                </p>
              </div>
            </div>
            {/* Zweite Säulen - über die gesamte Breite */}
            <div className="mt-8 pt-4" data-id="element-196">
              <h4 className="text-lg font-medium text-gray-700 mb-3" data-id="element-197">
                Unsere Arbeit ruht auf zwei Säulen:
              </h4>
              <div className="text-gray-600 space-y-4 mb-6" data-id="element-198">
                <div className="flex items-start" data-id="element-199">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-200"></div>
                  <p data-id="element-201">
                    Einerseits auf psychologischer und therapeutischer
                    Fachkenntnis – mit Schwerpunkten in Verhaltenstherapie,
                    systemischer Beratung, Paar- und Familientherapie.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-202">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-203"></div>
                  <p data-id="element-204">
                    Andererseits auf vielen Jahren Berufs- und Führungserfahrung
                    u.a. in internationalen DAX-Unternehmen.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Second Block */}
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-205">
            <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-206">
              <div className="w-full md:w-1/2" data-id="element-207">
                <ul className="text-gray-600 space-y-6 mb-6" data-id="element-208">
                  <li data-id="element-209">
                    <h4 className="text-lg font-medium text-gray-700 mb-2" data-id="element-210">
                      Breites methodisches Angebot:
                    </h4>
                    <p data-id="element-211">
                      Wissenschaftlich bewährte Methoden geben Ihnen die
                      Sicherheit, mit Ihren Anliegen professionelle
                      Unterstützung zu erfahren und eine für Sie wirklich
                      passende Lösung zu finden.
                    </p>
                  </li>
                  <li data-id="element-212">
                    <h4 className="text-lg font-medium text-gray-700 mb-2" data-id="element-213">
                      Präziser diagnostischer Blick:
                    </h4>
                    <p data-id="element-214">
                      Im ersten Schritt genau hinzuschauen und Ihr Anliegen zu
                      verstehen, ist die Basis für einen Perspektivwechsel.
                    </p>
                  </li>
                  <li data-id="element-215">
                    <h4 className="text-lg font-medium text-gray-700 mb-2" data-id="element-216">
                      Qualitätssicherung unserer therapeutischen Arbeit:
                    </h4>
                    <div className="space-y-3 mt-2" data-id="element-217">
                      <div className="flex items-start" data-id="element-218">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-219"></div>
                        <p data-id="element-220">Gemeinsame Intervision</p>
                      </div>
                      <div className="flex items-start" data-id="element-221">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-222"></div>
                        <p data-id="element-223">Regelmäßig Supervision durch externe Supervisoren</p>
                      </div>
                      <div className="flex items-start" data-id="element-224">
                        <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-225"></div>
                        <p data-id="element-226">Kontinuierliche Weiterbildung</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="w-full md:w-1/2 flex-shrink-0 md:order-last" data-id="element-227">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gTjyTFupPZaWQoacbD7hxC/Kachel-Kugeln.jpg" alt="Dekorative Kugeln" className="w-full h-auto rounded-lg" data-id="element-228" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}